import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgForOf } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { Roles } from '../../shared/Enums';
import { ModalPricingService } from 'src/app/services/modal-pricing.service';
import { SharedModule } from '../../shared/shared.module';
import { ModalPricingComponent } from 'src/app/components/modal-pricing/modal-pricing.component';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';
import { AccountSettingService } from 'src/app/services/account-settings.service';
import { AccountResponse } from 'src/app/pages/account-settings/account-settings.component';
import { ServicesService } from 'src/app/services/services.service';
import { Service } from 'src/app/models/service.model';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profileCategory {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link?: string;
  action?: () => void;
  needsSubscription?: boolean,
  showToRole?: string[]
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NgScrollbarModule, TablerIconsModule, MaterialModule, SharedModule, ModalPricingComponent],
  providers: [MessageService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  showPricingModal: boolean = false

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  accountCountryList = [
    { "name": "Australia", "code": "AU" },
    { "name": "Austria", "code": "AT" },
    { "name": "Belgium", "code": "BE" },
    { "name": "Brazil", "code": "BR" },
    { "name": "Bulgaria", "code": "BG" },
    { "name": "Canada", "code": "CA" },
    { "name": "Cyprus", "code": "CY" },
    { "name": "Czech Republic", "code": "CZ" },
    { "name": "Denmark", "code": "DK" },
    { "name": "Estonia", "code": "EE" },
    { "name": "Finland", "code": "FI" },
    { "name": "France", "code": "FR" },
    { "name": "Germany", "code": "DE" },
    { "name": "Greece", "code": "GR" },
    { "name": "Hong Kong", "code": "HK" },
    { "name": "Hungary", "code": "HU" },
    { "name": "India", "code": "IN" },
    { "name": "Ireland", "code": "IE" },
    { "name": "Italy", "code": "IT" },
    { "name": "Japan", "code": "JP" },
    { "name": "Latvia", "code": "LV" },
    { "name": "Lithuania", "code": "LT" },
    { "name": "Luxembourg", "code": "LU" },
    { "name": "Malta", "code": "MT" },
    { "name": "Mexico", "code": "MX" },
    { "name": "Netherlands", "code": "NL" },
    { "name": "New Zealand", "code": "NZ" },
    { "name": "Norway", "code": "NO" },
    { "name": "Poland", "code": "PL" },
    { "name": "Portugal", "code": "PT" },
    { "name": "Romania", "code": "RO" },
    { "name": "Singapore", "code": "SG" },
    { "name": "Slovakia", "code": "SK" },
    { "name": "Slovenia", "code": "SI" },
    { "name": "Spain", "code": "ES" },
    { "name": "Sweden", "code": "SE" },
    { "name": "Switzerland", "code": "CH" },
    { "name": "Thailand", "code": "TH" },
    { "name": "United Kingdom", "code": "GB" },
    { "name": "United States", "code": "US" },
  ]

  user?: User;
  filteredProfileCategories: profileCategory[] = [];
  userRole: string = ""
  public showFreeTrialValue = false;
  progress: number = 0
  userHasConnectedStripeId: boolean = false
  userHasProFeatures: boolean = false
  accountForm: FormGroup
  connectAccountModalVisible: boolean = false
  services: Service[] = [];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    public modalPricingService: ModalPricingService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private addresService: AccountSettingService,
    private servicesService: ServicesService
  ) {

    this.user = userService.user

    if (this.user.connectedStripeId) {
      this.userHasConnectedStripeId = true
    }

    this.createAccountForm();
    this.checkProFeatures();

    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.formatUserRole()
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  checkProFeatures() {
    this.servicesService.getServices().subscribe((services) => {
      this.services = services;
      this.userHasProFeatures = services.some(service => service.name === "Pro features");

      // Filtramos las categorías aquí, cuando ya sabemos si tiene Pro features
      this.filteredProfileCategories = this.profileCategories.filter(profile => {
        const hasSubscription = !profile.needsSubscription || !!this.user.subscriptionID;
        const roleAllowed = profile.showToRole.includes(this.userRole);

        // Si la categoría es Connect Stripe, sólo la mostramos si se cumplen estos requisitos
        if (profile.id === 3) {
          return hasSubscription && roleAllowed && !this.user.connectedStripeId && this.userHasProFeatures;
        }

        return hasSubscription && roleAllowed;
      });
    });
  }

  get scrollbarHeight(): string {
    // Altura base del header del perfil (User Profile + imagen + info) ≈ 200px
    // Cada item de categoría ≈ 80px
    // Botón de logout ≈ 60px
    const baseHeight = 200;
    const itemHeight = 80;
    const logoutHeight = 60;
    const calculatedHeight = baseHeight + (this.filteredProfileCategories.length * itemHeight) + logoutHeight;

    // Máximo 900px
    return `${Math.min(calculatedHeight, 900)}px`;
  }

  formatUserRole() {
    if (this.user.role === Roles.ROLE_DISTRIBUTOR) {
      this.userRole = "Distributor"
    }

    if (this.user.role === Roles.ROLE_CLINIC) {
      this.userRole = "Clinic"
    }

    if (this.user.role === Roles.ROLE_CUSTOMER) {
      this.userRole = "Client"
    }

  }

  logout() {
    this.authService.logout();
  }

  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  profileCategories: profileCategory[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'PROFILE_CATEGORIES.MY_PROFILE',
      subtitle: 'PROFILE_CATEGORIES.ACCOUNT_SETTINGS',
      link: '/account-settings',
      needsSubscription: false,
      showToRole: ['Distributor']
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-office-bag.svg',
      title: 'PROFILE_CATEGORIES.BILLING',
      subtitle: 'PROFILE_CATEGORIES.MANAGE_BILLING',
      action: () => this.showStripeBilling(),
      needsSubscription: true,
      showToRole: ['Distributor']
    },
    {
      id: 3,
      img: '/assets/images/svgs/stripe.png',
      title: 'PROFILE_CATEGORIES.CONNECT_STRIPE',
      subtitle: 'PROFILE_CATEGORIES.RECEIVE_PAYMENTS',
      action: () => this.showConnectAccountModal(),
      needsSubscription: true,
      showToRole: ['Client']
    },
    {
      id: 4,
      img: '/assets/images/tutorial-icon.png',
      title: 'PROFILE_CATEGORIES.TUTORIALS',
      subtitle: 'PROFILE_CATEGORIES.LEARN_STEP_BY_STEP',
      action: () => this.openTutorials(),
      needsSubscription: false,
      showToRole: ['Distributor']
    },
    {
      id: 5,
      img: '/assets/images/svgs/faq.png',
      title: 'PROFILE_CATEGORIES.FAQ',
      subtitle: 'PROFILE_CATEGORIES.FREQUENTLY_ASKED_QUESTIONS',
      action: () => this.openFAQ(),
      needsSubscription: false,
      showToRole: ['Distributor', 'Client', 'Clinic']
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/t',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/',
    },
  ];

  startFreeTrial() {
    this.userService.updateUserFreeTrial().subscribe((user) => {
      window.location.reload();
    })
  }

  calculateRemainingDays() {
    const TRIAL_PERIOD_LENGTH = 15

    const trialStartedAt = new Date(this.user.trialStartedAt);

    const trialEndDate = new Date(trialStartedAt);
    trialEndDate.setDate(trialEndDate.getDate() + TRIAL_PERIOD_LENGTH);

    const currentDate = new Date();
    const remainingDuration = trialEndDate.getTime() - currentDate.getTime();

    const remainingDays = Math.ceil(remainingDuration / (1000 * 60 * 60 * 24));

    if (remainingDays <= 0) {
      this.progress = 100
    } else {
      const daysPassed = TRIAL_PERIOD_LENGTH - remainingDays;
      this.progress = (daysPassed / TRIAL_PERIOD_LENGTH) * 100;
      this.progress = Math.round(this.progress)
    }

    return remainingDays;
  }

  handleClick(category: profileCategory): void {
    if (category.action) {
      // Ejecuta la acción personalizada si está definida
      category.action();
    } else if (category.link) {
      // Navega a la ruta especificada si no hay acción personalizada
      this.router.navigateByUrl(category.link);
    }
  }

  createAccountForm(): void {
    this.accountForm = this.fb.group({
      country: ['', [Validators.required]]
    })
  }

  connectAccount() {
    if (this.accountForm.valid) {
      Swal.showLoading()
      this.connectAccountModalVisible = false;
      const countryCode = this.accountForm.value.country.code;
      this.addresService.connectAccount(countryCode).subscribe({
        next: (res: AccountResponse) => {
          Swal.close()
          this.accountForm.reset();
          window.open(res.url, '_blank');
          // this.router.navigateByUrl(res.url)
          // window.location.href = res.url;
        },
        error: (error) => {
          console.error("Error connecting account: ", error)
          Swal.close()
          this.accountForm.reset();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        }
      })
    }
  }

  showStripeBilling() {
    this.userService.getPortalSession()
  }

  showConnectAccountModal() {
    this.connectAccountModalVisible = true
  }

  openFAQ(): void {
    window.open('/faq');
  }

  openTutorials(): void {
    window.open('https://www.notion.so/Laboratories-role-20dd0a993da980fd9c72f4577eed98ab?source=copy_link');
  }
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    NgForOf,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
